import React, { Component } from 'react'
import { connect } from 'react-redux'
import './comment.scss'

import { createNote } from '../../../../actions/notes'
import { renderFullDate } from '../../../../utils/time'
import { translation } from '../../../../utils/helpers'
import { hasAccess } from '../../../../utils/auth'
import { formatArrayToString } from '../../../../utils/array'
import { DepartmentType } from '../../../../constants'

// Elements
import Textarea from '../../../elements/textarea'
import Check from '../../../elements/check'
import PanelHeader from '../../../elements/panelHeader'

class Comment extends Component {
  constructor (props) {
    super(props)
    this.isSaving = false

    this.state = {
      order: props.order !== undefined && props.order !== null ? props.order : null,
      note: {
        Note: '',
        OrderPrices: [],
        DeviationId: 0,
        OrderID: 0,
        NoteTypeID: 0,
        ApplyToInvoice: false,
        ShowToCustomer: false,
        ShowToPaintShop: false
      },
      hasChanged: false
    }
    this.onChange = this.onChange.bind(this)
    this.createSave = this.createSave.bind(this)
    this.ensureSaved = this.ensureSaved.bind(this)
  }

  componentDidMount () {
    this.componentWillReceiveProps(this.props)

    if (this.props.onRef) {
      this.props.onRef(this.ensureSaved)
    }
  }

  componentWillReceiveProps (next) {
    if (typeof next.order !== 'object') return

    const comment = next.comment || {}

    this.setState({
      order: next.order,
      note: {
        ...this.state.note,
        ...comment
      }
    })
  }

  onChange (e) {
    e.persist()
    let value = e.target.value
    let extra = {}

    if (e.target.type === 'checkbox') {
      value = e.target.checked
      if (e.target.name === 'NoteTypeID') {
        value = (value) ? 1 : 0
      }
    }

    if (e.target.name === 'ShowToCustomer' && !value) {
      extra.ShowToPaintShop = false
    }

    this.setState({
      note: {
        ...this.state.note,
        [e.target.name]: value,
        ...extra
      },
      hasChanged: true
    }, () => {
      if (e.target.type === 'checkbox') {
        this.createSave(e, true)
      }
    })
  }

  ensureSaved () {
    const wait = (until, doAfter) => {
      if (until() === true) return doAfter()

      setTimeout(() => {
        wait(until, doAfter)
      }, 100)
    }

    if (this.state.hasChanged && !this.isSaving) {
      return this.createSave()
    } else {
      // Wait until it is done saving
      return new Promise(resolve => {
        wait(
          () => !this.isSaving,
          () => resolve()
        )
      })
    }
  }

  createSave (e, fromCheckbox) {
    this.isSaving = true
    return new Promise(resolve => {
      let { note } = this.state
      if ((note.NoteID === 0 || note.NoteID === undefined) && fromCheckbox === true) return null
      note.OrderID = this.state.order.Id
      if (typeof this.props.orderPriceId === 'number') {
        if (note.OrderPrices === null) note.OrderPrices = []
        note.OrderPrices.push(this.props.orderPriceId)
      }
      if (typeof this.props.deviationId === 'number') note.DeviationId = this.props.deviationId
      if (typeof this.props.changeSource === 'number') note.SourceID = this.props.changeSource

      if (note.SourceID === 19) {
        note.ReturnType = 1
      }

      if (typeof note.Note !== 'string') {
        note.Note = note.Note.join('\n')
      }

      this.props.createNote(note).then((res) => {
        let newNote = res.data

        if (this.props.setComment) {
          this.props.setComment(newNote).then(() => {
            resolve()
            this.isSaving = false
          })
        } else {
          resolve()
          this.isSaving = false
        }
        this.setState({
          note: newNote
        })
      }, () => {
        window.toastr.error(translation('1917'), translation('216'))
      })
    })
  }

  render () {
    if (!this.state.order) return null
    const { transferDeviation } = this.props
    let isCustomer = hasAccess([4], this.props.auth.user.UserType)
    let isInternalDeviation = this.props.changeSource === 9
    let isBodyShop = this.props.auth.departmentType === DepartmentType.Body
    let isReferred = this.state.order.IsReferredIn || this.state.order.IsReferredOut
    let isReferredBody = isBodyShop && isReferred
    let disableTransferToInvoice = true
    if (transferDeviation === undefined || transferDeviation === null || transferDeviation) disableTransferToInvoice = false

    const renderOptions = () => {
      return (
        <div className='comment_options'>
          <Check labelText={translation(isBodyShop ? 17874 : 17857)} id='Comment_ShowToCustomer' name='ShowToCustomer' onChange={this.onChange} checked={this.state.note.ShowToCustomer} />
          {(isBodyShop || hasAccess([6], this.props.auth.user.UserType)) && (<Check labelText={translation(isBodyShop ? 17875 : 17858)} disabled={isReferredBody && !this.state.note.ShowToCustomer} id='Comment_ShowToPaintShop' name='ShowToPaintShop' onChange={this.onChange} checked={this.state.note.ShowToPaintShop} />)}
          <Check labelText={translation('1785')} id='Comment_TransferToInvoice' name='ApplyToInvoice' onChange={this.onChange} checked={this.state.note.ApplyToInvoice} disabled={disableTransferToInvoice} />
        </div>
      )
    }

    // Render
    return (
      <div className='price_comments'>
        <PanelHeader text={translation('149')} />
        <Textarea name='Note' onBlur={this.createSave} value={formatArrayToString(this.state.note.Note)} onChange={this.onChange} />
        {!isCustomer && !isInternalDeviation && renderOptions()}
        {this.state.order.IsEvaluated && this.props.renderEval &&
          <div className='whoDiditBox'>
            <div>{translation('372')} {renderFullDate(this.state.order.IsEvaluatedDate)}</div>
            <div>{translation('763')} {this.state.order.IsEvaluatedBy}</div>
          </div>
        }
      </div>
    )
  }
}

Comment.PropTypes = {
  changeSource: React.PropTypes.number.isRequired,
  order: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  createNote
})(Comment)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/Comment/index.js